import React from "react";

// SectionHead — clean architectural label. NO kana characters.
// Renders mono section number/name on the left, optional right-aligned slot.
export default function SectionHead({ roman, right }) {
  return (
    <div className="section-head" data-testid="section-head">
      <div className="col-span-6 md:col-span-6 flex items-center gap-3">
        <span className="idx-line" aria-hidden="true" />
        <span className="mono" style={{ color: "var(--ink)" }}>
          {roman}
        </span>
      </div>
      {right !== undefined && (
        <div className="col-span-6 md:col-span-6 flex justify-end items-end">
          {right}
        </div>
      )}
    </div>
  );
}
